import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../core/service/v2/abstractRepositoryV2";
import {ProviderServiceModel} from "../../../api/entity/providerService.model";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceRepository extends AbstractRepositoryV2<ProviderServiceModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ProviderService', serviceElementsFactory, injector);
    }
}
